import { createRouter, createWebHistory } from 'vue-router'
import UploadView from './views/UploadView.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'upload', component: UploadView },
    { path: '/album', name: 'album', component: () => import('./views/AlbumView.vue') },
    { path: '/plakat', name: 'poster', component: () => import('./views/PosterView.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})
